<template>
  <div class="search-item">
    <div class="delete-icon" v-if="isRemove" @click="removeItem">
      <svg-icon iconClass="delete" />
    </div>
    <el-select
      class="select-container"
      v-model="selectVal"
      filterable
      placeholder="查询类型"
      value-key="prop"
    >
      <template v-for="searchItem in tableColumns">
        <template v-if="searchItem.search === undefined || searchItem.search">
          <el-option
            :key="searchItem.prop"
            :value-key="searchItem.prop"
            :label="searchItem.label"
            :value="searchItem.label"
          />
        </template>
      </template>
    </el-select>
    <div>
      <valueItemVue :search-type="searchType" v-model="searchVal" />
    </div>
  </div>
</template>

<script setup>
import { isNull } from "@/utils/fangerUtils";
import { onMounted, ref, watch } from "vue";
import valueItemVue from "./valueItem.vue";

const props = defineProps({
  tableColumns: {
    required: true,
    type: Object,
  },
  searchIndex: {
    required: false,
    type: Number,
    default: 0,
  },
  isRemove: {
    // 是否显示可以删除的图标
    required: false,
    type: Boolean,
    default: true,
  },
  // 重置参数
  reset: {
    required: false,
    type: Boolean,
    default: false,
  },
  defaultType: {
    required: false,
    type: String,
    default: "",
  },
  // 默认值
  defaultVal: {
    required: false,
    default: "",
  },
});

const selectVal = ref("");
const selectDict = {};
const searchType = ref({});
const searchVal = ref("");

// 初始化值
const initialVal = () => {
  if (props.defaultVal !== "") {
    const types = props.tableColumns.filter(
      (item) => item.prop === props.defaultType
    );
    if (types.length === 1) {
      searchType.value = types[0];
      selectVal.value = types[0].label;
      searchVal.value = {
        val: props.defaultVal,
      };
    }
  } else {
    searchType.value = {};
    selectVal.value = "";
    searchVal.value = "";
  }
};
initialVal(); // 初始化参数

const emits = defineEmits(["updateVal", "removeItem"]);

let _initSelectVal = false;
let _initSearchVal = false;
onMounted(() => {
  // 整理选项值的字典
  props.tableColumns.forEach((item) => {
    selectDict[item.label] = item;
  });

  watch(
    () => props.reset,
    (newVla) => {
      _initSelectVal = true;
      _initSearchVal = true;
      initialVal(); // 重置值
    }
  );

  watch([selectVal, searchVal], ([newType, newVal], [oldType]) => {
    if (_initSearchVal) {
      _initSearchVal = false;
      return;
    }
    if (isNull(newType) && isNull(newVal.type) && !isNull(newVal.val?.value)) {
      // 搜索类型为空,值不为空，只填入值，类型默认使用第一个类型
      selectVal.value = props.tableColumns[0].label;
      newVal.type = props.tableColumns[0].prop;
      newVal.val.column = props.tableColumns[0].prop;
      // emits('updateVal',props.searchIndex,'',newVal2)
    }
    let type = "";
    let val = "";
    if (newVal.type && newVal.val) {
      type = newVal.type;
      val = newVal.val;
    }
    emits("updateVal", props.searchIndex, type, val);
  });

  watch(selectVal, (newVal) => {
    if (_initSelectVal) {
      _initSelectVal = false;
      return;
    }
    let _searchType = selectDict[newVal];
    if (!_searchType) {
      _searchType = {};
    }
    searchType.value = _searchType;
  });
});

// 删除item
const removeItem = () => {
  emits("removeItem", props.searchIndex);
};
</script>
<style lang="scss" scoped>
.search-item {
  display: flex;
  height: 33px;

  .delete-icon {
    line-height: 30px;
    margin-right: 5px;
  }

  .delete-icon:hover {
    color: red;
  }

  .select-container {
    width: 150px;
  }

  .search-btn {
    margin-left: 10px;
  }
}
</style>
